<template>
  <div class="md-size-100">
    <div class="form-time-container" :class="{ 'has-value': hasValue }">
      <label v-if="label" class="floating-label">{{ placeholder }}</label>
      <vue-timepicker
        class="form-time-picker"
        :style="{
          'background-color': disabled ? '#efefef4d' : '',
        }"
        ref="timepicker"
        v-model="timeObject"
        :placeholder="placeholder"
        lazy
        :disabled="disabled"
        :key="timeObjectKey"
        format="HH:mm"
        clearable
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "FormTime",
  props: {
    value: {
      type: [String, Object, null],
      default: null,
    },
    placeholder: {
      type: String,
      default: "Select Time",
    },
    outputFormat: {
      type: String,
      default: "HH:MM:00",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      timeObjectKey: 0,
      timepicker: null,
      timeObject: null,
      hasValue: false,
    };
  },

  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal === null || newVal === undefined || newVal === "") {
          this.timeObject = null; // Ensure the input is cleared
          this.timeObjectKey += 1;
          this.hasValue = false;
          this.$emit("input", null); // Emit null to ensure parent is updated
          return;
        }

        if (typeof newVal === "string") {
          const timeParts = newVal.match(/(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?/);
          if (timeParts) {
            const hours = parseInt(timeParts[1], 10);
            const minutes = parseInt(timeParts[2], 10);
            if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
              this.timeObject = {
                HH: timeParts[1].padStart(2, "0"),
                mm: timeParts[2].padStart(2, "0"),
              };
              this.hasValue = true;
            } else {
              this.timeObject = null;
              this.hasValue = false;
              this.$emit("input", null);
            }
          } else {
            this.timeObject = null;
            this.hasValue = false;
            this.$emit("input", null);
          }
        } else {
          this.timeObject = newVal;
          this.hasValue = newVal && Object.keys(newVal).length > 0;
        }
      },
    },

    timeObject: {
      deep: true,
      handler(newVal) {
        if (newVal && newVal.HH && newVal.mm) {
          let formattedTime;
          if (this.outputFormat === "HH:MM") {
            formattedTime = `${newVal.HH}:${newVal.mm}`;
          } else {
            formattedTime = `${newVal.HH}:${newVal.mm}:00`;
          }
          this.hasValue = true;
          this.$emit("input", formattedTime);
        } else {
          this.hasValue = false;
          this.$emit("input", null);
        }
      },
    },
  },
};
</script>

<style lang="scss">
.form-date {
  margin-top: 14px;
  width: 100%;
  /* margin-top: 15px; */
  border-bottom: 1px solid #ccc;

  input,
  input:focus {
    border: none !important;
    width: 100% !important;
    outline: none;
  }

  .controls {
    left: 0;
    /* position: relative; */
  }

  /* Ensure clear button is styled */
  .clear-btn {
    cursor: pointer;
    color: #999;
  }
}

.form-week {
  margin-top: 10px;
  text-align: center;
  padding-inline: 20px;
  .time-picker {
    width: 100%;
    padding: 5px 10px;
    border: 1px solid #ccc !important;
    border-radius: 4px;
    input {
      border: 0;
      padding: 10px;
    }
  }
  .controls {
    left: 0;
  }
}

.form-time-container {
  position: relative;
  width: 100%;
  padding-top: 15px;
  /* margin-bottom: 10px; */
  /* border-bottom: 1px solid #ccc; */

  .floating-label {
    position: absolute;
    top: 15px;
    right: 0;
    transition: all 0.3s ease;
    font-size: 14px;
    color: rgba(0, 0, 0);
    pointer-events: none;
  }

  &.has-value .floating-label {
    top: -5px;
    font-size: 12px;
    /* color: #2196f3; */
  }

  /* &:focus-within .floating-label {
    top: -5px;
    font-size: 12px;
    color: #2196f3;
  } */
}

.form-time-picker {
  width: 100%;
  .select-list {
    flex-direction: row-reverse !important;
  }

  input {
    border: none !important;
    width: 100% !important;
    outline: none;
    padding: 4px 0;
    text-align: right;
    direction: rtl;
    font-size: 14px;
  }
}
</style>
